import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TTManageMappingList from './TTManageMappingList';
import {
  createMatchColListItem,
  updateMatchColListItem,
  deleteMatchColListItem,
  uploadFileTTListItems
} from 'redux/translationTable/TranslationTableActions';

const mapStateToProps = ({ translationTable }, ownProps) => ({
  listItems: translationTable.lists.find(list => (ownProps.sourceInputId === list.sourceInputId)),
  tableId: translationTable.translationTable.id,
  fetchingTranslationTableData: translationTable.fetchingTranslationTableData
});

const mapDispatchToProps = dispatch => ({
  ttActions: bindActionCreators({ createMatchColListItem, updateMatchColListItem, deleteMatchColListItem, uploadFileTTListItems }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TTManageMappingList);



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttManageMappingList/TTManageMappingListConnector.js